<!-- src/App.vue -->
<template>
  <div class="fixed inset-0 min-h-screen flex flex-col overflow-auto">
    <NavigationBar />
    <div class="flex-grow relative">
      <router-view />
      <AuthModal />
    </div>
    <AppFooter />
    <OnboardingTour ref="tourRef" />
    <CookieConsent />
    <LocaleBanner />

    <!-- Tour button: desktop only, landing pages only -->
    <Teleport to="body">
      <button
        v-if="isLandingPage"
        @click="tourRef?.startTour()"
        aria-label="Take a tour"
        title="Take a tour"
        class="fixed bottom-5 right-5 z-[9994] hidden sm:flex items-center gap-1.5 bg-white hover:bg-gray-50 active:scale-95 text-gray-600 hover:text-blue-600 text-xs font-semibold px-3 py-2 rounded-full shadow-md border border-gray-200 transition-all duration-150 select-none"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>Tour</span>
      </button>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import NavigationBar from "@/components/NavigationBar.vue";
import AuthModal from "@/components/AuthModal.vue";
import AppFooter from "@/components/AppFooter.vue";
import OnboardingTour from "@/components/OnboardingTour.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import LocaleBanner from "@/components/LocaleBanner.vue";

const tourRef = ref(null)

const route = useRoute()

const isLandingPage = computed(() => {
  const path = route.path
  return path === '/' || 
         path === '/searches/basic' || 
         path === '/searches/weather' || 
         path === '/searches/buddy' || 
         path === '/explore'
})
</script>

<style>
/* Ensure full height and flexible layout */
html, body, #app {
  height: 100%;
  margin: 0;
}
</style>
